import * as React from 'react';
// Import ciblé (pas le barrel @erp/ui) : le portail pro n'utilise pas les
// composants shadcn, on ne tire que les helpers purs.
import { formatDecimalValue, normalizeDecimalText, parseDecimal, sanitizeDecimalTyping } from '@erp/ui/lib/decimal';

export interface DecimalTextInputProps
  extends Omit<
    React.ComponentProps<'input'>,
    'type' | 'inputMode' | 'value' | 'defaultValue' | 'onChange' | 'step' | 'min' | 'max'
  > {
  value: number | string | null | undefined;
  /** Nombre parsé à chaque frappe (NaN si vide). */
  onValueChange?: (value: number) => void;
  /** Chaîne machine (`.` décimal) à chaque frappe, `''` si vide. */
  onTextChange?: (text: string) => void;
  maxDecimals?: number;
}

/**
 * Équivalent non stylé du DecimalInput de @erp/ui pour le portail pro
 * (design custom, pas de shadcn) : saisie libre virgule OU point,
 * autocorrection en virgule au blur. Voir libs/ui/src/lib/decimal.ts.
 */
export function DecimalTextInput({
  value,
  onValueChange,
  onTextChange,
  maxDecimals = 3,
  onFocus,
  onBlur,
  ...props
}: DecimalTextInputProps) {
  const [focused, setFocused] = React.useState(false);
  const [text, setText] = React.useState('');

  const display = focused ? text : formatDecimalValue(value, maxDecimals);

  return (
    <input
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={display}
      onFocus={(e) => {
        setText(formatDecimalValue(value, maxDecimals));
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
      onChange={(e) => {
        const sanitized = sanitizeDecimalTyping(e.target.value, { maxDecimals, allowNegative: false });
        setText(sanitized);
        onTextChange?.(normalizeDecimalText(sanitized));
        onValueChange?.(parseDecimal(sanitized));
      }}
      {...props}
    />
  );
}
